import React from "react";
import { Modal as MaterialModal } from "@material-ui/core";

export function Modal({ open, onClose, children }) {
  return (
    <MaterialModal
      open={open}
      onClose={onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      {children}
    </MaterialModal>
  );
}



// WEBPACK FOOTER //
// ./src/pages/patientplaylist/InfoDoctor/Modal.jsx